<template>
  <div class="number-col" :class="color">
    <div class="inner">
      <span class="number">{{number}}</span>
      <span class="title">{{title}}</span>
      <span class="caption">{{caption}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "NumberColumn",
  props: {
    number: String,
    title: String,
    caption: String,
    color: String
  }
}
</script>

<style scoped>
  .number-col {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
  }
  .pink {
    color: #C7125C;
  }
  .blue {
    color: #102D61;
  }
  .yellow {
    color: #FCC500;
  }
  .gradient span {
    background: linear-gradient(70deg, #B1D995 0%, #3CB2B8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  span {
    display: block;
  }
  .number {
    font-size: 72px;
    font-weight: 700;
    line-height: 1;
  }
  .title {
    font-size: 30px;
    font-weight: 700;
    margin-bottom: 0.5em;
  }
  .caption {
    font-size: 20px;
    font-weight: 500;
    margin: 5% 8%;
  }
  .gradient .number {
    font-size: 120px;
  }
  .gradient .title {
    font-size: 36px;
  }
  @media(min-width: 568px) and (max-width: 999px) {
    .number {
      font-size: 58px;
    }
    .title {
      font-size: 24px;
    }
    .caption {
      font-size: 18px;
    }
  }
</style>